import React, { Component } from 'react';
import PropTypesImmutable from 'react-immutable-proptypes';
import { Form, Field } from 'react-final-form';
import PropTypes from 'prop-types';
import { getLoadingSelector, getEntityById } from '../../utils/asyncHelpers';
import { DateRangeField, SelectField, ClassificatorField } from '../../atoms';
import { FormActions } from '../../components';
import { connect } from 'react-redux';
import { FORM_CONSUMER_GO_SEARCH } from '../../constants/formKeys';
import { formConsumerGoSearchFields } from '../../constants/forms/formConsumerGoSearch';
import {
  getMeteringPoints,
  getMeteringPointsData,
} from '../../reducers/consumerGoSearchReducer';
import { Collapse, Row, Col, Button, Spin } from 'antd';
import { downloadFileByPostURL } from '../../utils/files';
import { meteringPointFields } from '../../constants/meteringPoint';
import { getPhysicalPersonId } from '../../reducers/userReducer';
import { FORMAT_DEFAULT_DATE } from '../../utils/dates';
import { measurement as meteringPointSchema } from '../../schemas';
import { links } from '../../utils/gotoLink';
import * as actions from '../../actions/actionCreators/consumerGoSearchActionCreators';
import MeteringPoint from './MeteringPoint';
import dayjs from '../../utils/dayjs';
import RffFields from '../../atoms/rff/RffFields';
import FormStateToRedux from '../FormStateToRedux';
import {
  updateFormState,
  formValueSelector,
} from '../../reducers/reactFinalFormReducer';

const { Panel } = Collapse;

export class ConsumerGoFilter extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    selectedPoint: PropTypesImmutable.map,
    filterValues: PropTypesImmutable.map,
    meteringPoints: PropTypesImmutable.list.isRequired,
    searchConsumerGo: PropTypes.func.isRequired,
    isLoadingPoints: PropTypes.bool.isRequired,
    fetchConsumerPoints: PropTypes.func.isRequired,
    consumerId: PropTypes.number.isRequired,
    initialValues: PropTypes.object,
    updateFormState: PropTypes.func.isRequired,
  };

  componentDidMount = () => {
    const {
      searchConsumerGo,
      fetchConsumerPoints,
      consumerId,
      initialValues,
      updateFormState,
    } = this.props;

    // Initialize Redux state before search reads it
    updateFormState(FORM_CONSUMER_GO_SEARCH, { values: initialValues });
    searchConsumerGo();
    fetchConsumerPoints(consumerId);
  };

  onClear = (form) => {
    const { initialValues, updateFormState, searchConsumerGo } = this.props;
    form.restart(initialValues);
    updateFormState(FORM_CONSUMER_GO_SEARCH, { values: initialValues });
    searchConsumerGo();
  };

  handleExportData = () => {
    const { filterValues } = this.props;

    downloadFileByPostURL(
      links.consumerReportExportCsv,
      filterValues ? filterValues.toJS() : {},
      'gos.csv'
    );
  };

  onSubmit = () => {
    this.props.searchConsumerGo();
  };

  render() {
    const { t, isLoadingPoints, meteringPoints, selectedPoint, initialValues } =
      this.props;

    return (
      <div className="global-margin-top-16">
        <Form
          onSubmit={this.onSubmit}
          initialValues={initialValues}
          render={({ handleSubmit, form }) => (
            <Collapse defaultActiveKey={['filters']}>
              <Panel key="filters" header={t('filter.panelTitle')}>
                <form onSubmit={handleSubmit}>
                  <FormStateToRedux form={FORM_CONSUMER_GO_SEARCH} />
                  <Row gutter={32}>
                    <Col span={8}>
                      <RffFields
                        label={t('filter.dateRange')}
                        names={[
                          formConsumerGoSearchFields.START_DATE,
                          formConsumerGoSearchFields.END_DATE,
                        ]}
                        component={DateRangeField}
                        allowClear={false}
                        hasFeedback={false}
                        dateFormat={FORMAT_DEFAULT_DATE}
                      />
                    </Col>
                    <Col span={8}>
                      <Spin spinning={isLoadingPoints}>
                        <Field
                          label={t('filter.meteringPoint')}
                          name={formConsumerGoSearchFields.METERING_POINT_ID}
                          component={SelectField}
                          options={meteringPoints.toJS()}
                          valueKey={meteringPointFields.ID}
                          labelKey={meteringPointFields.EICZ_CODE}
                          hasFeedback={false}
                        />
                      </Spin>
                    </Col>
                    <Col span={8}>
                      <Field
                        label={t('filter.consumptionUsage')}
                        name={formConsumerGoSearchFields.CONSUMPTION_USAGE_ID}
                        component={ClassificatorField}
                        classificatorType={
                          ClassificatorField.types.consumptionUsage
                        }
                        hasFeedback={false}
                      />
                    </Col>
                  </Row>
                  <FormActions>
                    <Button onClick={() => this.onClear(form)}>
                      {t('filter.clearBtn')}
                    </Button>
                    <Button type="primary" htmlType="submit">
                      {t('filter.submitBtn')}
                    </Button>
                  </FormActions>
                </form>
              </Panel>
            </Collapse>
          )}
        />
        <FormActions>
          <Button onClick={this.handleExportData}>
            {t('filter.exportCsvBtn')}
          </Button>
        </FormActions>
        {selectedPoint && (
          <MeteringPoint meteringPoint={selectedPoint.toJS()} t={t} />
        )}
      </div>
    );
  }
}

const getValues = formValueSelector(FORM_CONSUMER_GO_SEARCH);

const getIsLoadingPoints = getLoadingSelector(getMeteringPoints);

const mapStateToProps = (state) => {
  const filterValues = getValues(state);
  const initialValues = {
    [formConsumerGoSearchFields.START_DATE]: dayjs()
      .startOf('year')
      .format(FORMAT_DEFAULT_DATE),
    [formConsumerGoSearchFields.END_DATE]: dayjs().format(FORMAT_DEFAULT_DATE),
  };

  return {
    filterValues,
    initialValues,
    isLoadingPoints: getIsLoadingPoints(state),
    meteringPoints: getMeteringPointsData(state),
    consumerId: getPhysicalPersonId(state),
    selectedPoint: getEntityById(
      state,
      meteringPointSchema,
      filterValues
        ? filterValues.get(formConsumerGoSearchFields.METERING_POINT_ID, 0)
        : 0
    ),
  };
};

const mapDispatchToProps = {
  searchConsumerGo: actions.searchConsumerGo,
  fetchConsumerPoints: actions.fetchConsumerPoints,
  updateFormState,
};

export default connect(mapStateToProps, mapDispatchToProps)(ConsumerGoFilter);
